export const resolveRecommendation = _ref => {
  let {
    data,
    recommendedProductName,
    t
  } = _ref;
  if (!data) {
    return null;
  }
  if (data.isFallback) {
    return {
      bullets: data.bullets.map((key, i) => t(key, {
        planName: recommendedProductName,
        defaultValue: ['More storage and team members as your business grows', 'Marketing and eCommerce tools to reach more customers', 'Business tools and integrations to help you do more'][i] ?? ''
      })),
      siteName: data.siteName,
      recommendedProductId: data.recommendedProductId
    };
  }
  return {
    bullets: data.bullets,
    siteName: data.siteName,
    recommendedProductId: data.recommendedProductId
  };
};
//# sourceMappingURL=resolveRecommendation.js.map